<div 
  class="checkbox-wrapper" 
  [attr.data-size]="size" 
  [attr.data-checked]="checked" 
  [attr.data-indeterminate]="indeterminate"
  [attr.data-disabled]="disabled" 
  [attr.data-required]="required"
  [attr.data-error]="error">
  
  <!-- Checkbox input -->
  <input 
    type="checkbox"
    class="checkbox-input"
    [id]="computedId"
    [name]="name"
    [value]="value"
    [checked]="checked"
    [disabled]="disabled"
    [required]="required"
    [attr.aria-describedby]="ariaDescribedBy"
    [attr.aria-invalid]="error"
    (change)="onCheckboxChange($event)">
  
  <!-- Custom checkbox visual -->
  <div class="checkbox-visual">
    <!-- Checkmark icon -->
    <svg 
      *ngIf="checked && !indeterminate" 
      class="checkbox-icon checkmark" 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M13.5 4.5L6 12L2.5 8.5" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"/>
    </svg>
    
    <!-- Indeterminate icon -->
    <svg 
      *ngIf="indeterminate" 
      class="checkbox-icon indeterminate" 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M4 8H12" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round"/>
    </svg>
  </div>
  
  <!-- Label -->
  <label 
    *ngIf="label" 
    class="checkbox-label" 
    [for]="computedId">
    {{ label }}
    <span *ngIf="required" class="required-indicator" aria-hidden="true">*</span>
  </label>
  
</div>
